import { CompositeDecorator } from 'draft-js';
import LinkAsAWordPlugin from './LinkAsAWordPlugin';
import LinkPlugin from './LinkPlugin';

const decorator = new CompositeDecorator([LinkPlugin, LinkAsAWordPlugin]);

export default decorator;
